module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"angular-messages","commonjs2":"angular-messages","amd":"angular-messages"}
// module id = 16
// module chunks = 0